import { render, staticRenderFns } from "./UserAuthenticated.vue?vue&type=template&id=cb4223a6&"
import script from "./UserAuthenticated.vue?vue&type=script&lang=js&"
export * from "./UserAuthenticated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports